import seatWidget from './seat-widget.js'
import { seatingChartWidth, seatingChartHeight } from '../checkout/share-seats.js'

export function getSeatWidgetImage(isReviewCartPage) {
  const SELECTEDSEATS = isReviewCartPage
    ? window.seatsInCartObj
    : selectedSeats
  // var selectedSeatsEidArray = Object.keys(SELECTEDSEATS)
  const SCHEDULE_EID = isReviewCartPage
    ? getCookie('scheduleEid')
    : myvars.scheduleEid
  let selectSeatsEid = ''
  let tickets = ''

  const chartWidth = 780
  const SEATINGCHARTHEIGHT = isReviewCartPage
    ? read_cookie('seatingChartSizeObj') != null
      ? read_cookie('seatingChartSizeObj').height
      : 0
    : seatingChartHeight
  const SEATINGCHARTWIDTH = isReviewCartPage
    ? read_cookie('seatingChartSizeObj') != null
      ? read_cookie('seatingChartSizeObj').width
      : 0
    : seatingChartWidth
  const chartRatio = isReviewCartPage
    ? SEATINGCHARTHEIGHT / SEATINGCHARTWIDTH
    : seatingChartHeight / seatingChartWidth


  let index = 0
  // var _seatsInCart = isReviewCartPage ? seatsInReviewCart : seatsInCart
  for (let seatEid in SELECTEDSEATS) {
    if (SELECTEDSEATS.hasOwnProperty(seatEid)) {
      const seat = SELECTEDSEATS[seatEid]
      const eid = isReviewCartPage ? seatEid : seat.eid
      if (index > 0) {
        tickets += '&'
        selectSeatsEid += ','
      }
      index++
      // if ($.inArray(seat.seatId, _seatsInCart) == -1) {
      tickets += 'items[]=' + eid
      selectSeatsEid += eid
      // }
    }
  }

  const chartWidgetImgSrc = seatWidget(
    SCHEDULE_EID,
    selectSeatsEid,
    chartWidth,
    chartRatio,
    true
  )
  const chartWidgetImgSrc_h = seatWidget(
    SCHEDULE_EID,
    selectSeatsEid,
    chartWidth,
    chartRatio
  )

  $('#hidden-cart-items').val(selectSeatsEid)
  $('#hidden-chartwidget-horizontal').val(chartWidgetImgSrc_h)
  $('#hidden-chartwidget-vertical').val(chartWidgetImgSrc)

  console.info('chartWidgetImgSrc: ' + chartWidgetImgSrc)
  console.info('chartWidgetImgSrc_h: ' + chartWidgetImgSrc_h)

  if (isReviewCartPage) {
    console.info('isReviewCartPage')
    console.info('SELECTEDSEATS: ' + SELECTEDSEATS)
    console.info('cartItems: ' + tickets)
  } else {
    console.info('ticketsItems: ' + tickets)
  }
}

export default getSeatWidgetImage
